const CET_ZONE = 'Europe/Berlin';
const DAY = 24 * 3600;

export const CREW_SHIFTS = [
    { id: '1', label: '1st', startLabel: '6:00 AM', color: 'blue' },
    { id: '2', label: '2nd', startLabel: '2:00 PM', color: 'orange' },
    { id: '3', label: '3rd', startLabel: '10:00 PM', color: 'purple' },
];

const START_SECONDS = [6 * 3600, 14 * 3600, 22 * 3600];

export function berlinClockSeconds(value) {
    if (value == null || value === '') return null;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: CET_ZONE,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23',
    }).formatToParts(date);
    const pick = (type) => Number(parts.find((part) => part.type === type).value);
    return (pick('hour') % 24) * 3600 + pick('minute') * 60 + pick('second');
}

export function crewShift(value) {
    const seconds = berlinClockSeconds(value);
    if (seconds == null) return null;
    let best = 0;
    let bestDist = Infinity;
    let bestElapsed = Infinity;
    START_SECONDS.forEach((start, index) => {
        const raw = Math.abs(seconds - start);
        const dist = Math.min(raw, DAY - raw);
        const elapsed = (seconds - start + DAY) % DAY;
        // ponytail: a dead tie (10:00, 18:00, 02:00) stays with the shift that already started
        if (dist < bestDist || (dist === bestDist && elapsed < bestElapsed)) {
            best = index;
            bestDist = dist;
            bestElapsed = elapsed;
        }
    });
    return CREW_SHIFTS[best];
}

export function crewShiftText(value) {
    const shift = crewShift(value);
    return shift ? `${shift.label} · ${shift.startLabel}` : '';
}
